/**
 * Ajuda dos campos de usuarios e perfis (P-USU-1).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6. O detalhe /usuarios/perfis herda de /usuarios.
 */

const cadastroDoUsuario: Record<string, string> = {
  'Tipo de perfil':
    'O que a pessoa pode fazer. Da para marcar mais de um perfil, e a pessoa recebe a soma. So aparecem os perfis atribuiveis.',
  'Tipo de documento': 'Fixo em CPF: o usuario e sempre pessoa fisica.',
  'Nome do usuario':
    'O nome da identidade. Quem tambem trabalha em outra empresa da plataforma tem o nome mudado so por ela mesma.',
  CPF: 'O servidor confere os digitos verificadores. A mascara e opcional e e retirada antes de gravar.',
  Telefone: 'Com o DDD, 10 ou 11 digitos. A mascara e opcional.',
  'E-mail':
    'E o acesso da pessoa: o convite vale so para este endereco, e depois ele nao muda por aqui.',
  CEP: 'Com os 8 digitos, o endereco e preenchido pela consulta de CEP quando ela esta ligada.',
  UF: 'A cidade so pode ser escolhida depois da UF.',
  Cidade: 'Os municipios do IBGE da UF escolhida.',
  'Corretora representada':
    'So para perfil com escopo de corretora: a pessoa enxerga apenas o que pertence a corretora escolhida, e nada sem corretora.',
};

export const ajuda: Record<string, Record<string, string>> = {
  '/usuarios': {
    ...cadastroDoUsuario,
    'Tela inicial':
      'A tela que abre no acesso de quem tem o perfil. Se a pessoa nao alcanca a tela, abre o Painel ou o primeiro item do menu dela.',
    'Perfil padrao':
      'O perfil ja marcado no Cadastrar Usuario. Ha um por publico: marcar este desmarca o anterior.',
    'Perfil atribuivel':
      'Desmarcado, o perfil sai do convite e da troca de perfil, e continua com quem ja o tem.',
  },
  '/corretora/usuarios': cadastroDoUsuario,
};
